import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Button } from '@/src/domains/design-system/components/Button'
import { useSelfAssessmentWizard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.context'
import { SelfAssessmentWizardCard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizardCard'

export const SelfAssessmentWizardIntro = () => {
  const { t } = getTranslate()
  const { definition, hasNavigated, handleStart } = useSelfAssessmentWizard()

  return (
    <SelfAssessmentWizardCard heading={definition.intro} autoFocus={hasNavigated}>
      <div className="flex">
        <Button type="button" size="medium" onClick={handleStart}>
          {t('component.button.start')}
        </Button>
      </div>
    </SelfAssessmentWizardCard>
  )
}
